module.exports = __webpack_public_path__ + "static/media/Daenerys Targaryen 1.1d15aef2.jpg";